import { For, Group, Button } from '@chakra-ui/react'
import { useCallback } from 'react'

import useGetObjectsByProperties from '@app/hooks/useGetObjectsByProperties'
import { useChatUpdateMutation } from '@graphql/queries'
const PipelineAssistantSelector = ({ pipelineId, chat }) => {
  const chatId = chat?.id

  // Clean up how we handle the ID vs a Dasherized Slug vs an Underscored Slug
  const dasherizedId = pipelineId.replaceAll('_', '-')
  const pipelines = useGetObjectsByProperties('pipeline', { slug: dasherizedId })
  const pipeline = pipelines?.[0]
  const assistants = pipeline?.assistants || []

  const currentAssistantId = chat?.currentAssistantId || assistants[0]?.id

  const [, updateChat] = useChatUpdateMutation()

  const setCurrentAssistantId = useCallback(
    (newAssistantId) => {
      if (chatId) {
        updateChat({ input: { chatId, currentAssistantId: newAssistantId } })
      }
    },
    [chatId, updateChat]
  )

  return (
    <Group>
      <For each={assistants}>
        {(assistant) => (
          <Button
            key={assistant.id}
            size="2xs"
            variant={currentAssistantId === assistant.id ? 'solid' : 'outline'}
            onClick={() => setCurrentAssistantId(assistant.id)}
          >
            {assistant.name}
          </Button>
        )}
      </For>
    </Group>
  )
}

export default PipelineAssistantSelector
